module.exports = __webpack_public_path__ + "static/home/img/5.e0a16774.png";